/**
 * RumType
 */
export type RumType =
  | 'DARK_RUM'
  | 'OVERPROOF'
  | 'RUM_LIQUEUR'
  | 'WHITE_RUM'
  | 'SPICED_RUM'
  | 'GOLD_RUM';

export const RumType = {
  DarkRum: 'DARK_RUM' as RumType,
  Overproof: 'OVERPROOF' as RumType,
  RumLiqueur: 'RUM_LIQUEUR' as RumType,
  WhiteRum: 'WHITE_RUM' as RumType,
  SpicedRum: 'SPICED_RUM' as RumType,
  GoldRum: 'GOLD_RUM' as RumType,
};
